export default __webpack_public_path__ + "img/cdcsvIXZ.9d165386.svg";